<ng-select
  class="w-100"
  [name]="name"
  [placeholder]="placeholder"
  [multiple]="multiple"
  [items]="options"
  groupBy="group"
  [groupValue]="groupValueFn"
  [selectableGroup]="true"
  [hideSelected]="true"
  [searchFn]="filterSelectItem"
  [ngModel]="model"
  (ngModelChange)="onModelChange($event)">

  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-icon left" (click)="clear(item);" aria-hidden="true">×</span>
    <span class="ng-value-label">
      {{ item.displayStatus }}
      @if (item.reason) {
        <span>
          - {{ item.displayReason }}
        </span>
      }
      @if (item.statusHasReasons && !item.reason) {
        <span>
          (All Reasons)
        </span>
      }
    </span>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    {{ item.displayStatus }}
    @if (item.reason) {
      <span>
        - {{ item.displayReason }}
      </span>
    }
  </ng-template>

  <ng-template ng-optgroup-tmp let-item="item">
    {{ item.displayStatus }}

    @if (item.statusHasReasons) {
      <span>
        (All Reasons)
      </span>
    }
  </ng-template>
</ng-select>
